/** Mutable state shared by the Pipeline DOM and its scene (no React renders). */
export interface PipelineState {
  /** Scroll progress through the pinned range, 0..1 (GSAP-scrubbed). */
  progress: { value: number }
  /** Reduced motion: the step in view (no scrubbing). */
  active: number
  /** Where the DOM leaves room for the art, in CSS px relative to the canvas. */
  layout: { artX: number; artY: number; artW: number; artH: number; version: number }
  /** The canvas's top in client px right now (pinned, before or after the pin). */
  canvasTop: () => number
  invalidate: (() => void) | null
}

export function createPipelineState(): PipelineState {
  return {
    progress: { value: 0 },
    active: 0,
    layout: { artX: 0, artY: 0, artW: 0, artH: 0, version: 0 },
    canvasTop: () => 0,
    invalidate: null,
  }
}
